import * as React from "react";
import { IconProps } from "../types";

const InboxIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g transform="translate(1.75 2.656) scale(1.1652)">
          <path
            d="M11.8322 6.02856C11.8144 5.93522 11.7879 5.84344 11.7529 5.754L10.1095 1.57033C9.87536 0.975333 9.30136 0.583333 8.66125 0.583333H3.78225C3.14291 0.583333 2.56814 0.974556 2.33402 1.57033L0.69058 5.754C0.65558 5.84267 0.629136 5.93444 0.611247 6.02856"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M8.36111 6.02854V6.80632C8.36111 7.23565 8.01267 7.58409 7.58333 7.58409H4.86111C4.43178 7.58409 4.08333 7.23565 4.08333 6.80632V6.02854H0.612111C0.593444 6.12576 0.583333 6.22376 0.583333 6.32332V8.75076C0.583333 9.60943 1.27944 10.3063 2.13889 10.3063H10.3056C11.165 10.3063 11.8611 9.60943 11.8611 8.75076V6.32332C11.8611 6.22454 11.851 6.12576 11.8323 6.02854H8.36111Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </g>
      </svg>
    );
  },
);

export default InboxIcon;
